<template>
    <header>
      <div class="logo-container">
        <img src="@/assets/rplogo.png" alt="Reliance Logo" class="logo" />
      </div>
      <div class="header-content">
        <p class="confirmation-text">
          {{ clientName }}, let’s confirm your policy information for your upcoming renewal with effective date {{ effectiveDate }}!
        </p>
      </div>
      <div class="progress-container">
        <div class="progress-bar">
          <div class="step" :class="{ completed: step > 1, active: step === 1 }">
            <span v-if="step > 1">&#10003;</span>
            <span v-else>1</span>
          </div>
          <div class="line"></div>
          <div class="step" :class="{ completed: step > 2, active: step === 2 }">
            <span v-if="step > 2">&#10003;</span>
            <span v-else>2</span>
          </div>
          <div class="line"></div>
          <div class="step" :class="{ completed: step > 3, active: step === 3 }">
            <span v-if="step > 3">&#10003;</span>
            <span v-else>3</span>
          </div>
          <div class="line"></div>
          <div class="step" :class="{ completed: step > 4, active: step === 4 }">
            <span v-if="step > 4">&#10003;</span>
            <span v-else>4</span>
          </div>
          <div class="line"></div>
          <div class="step" :class="{ completed: step > 5, active: step === 5 }">
            <span v-if="step > 5">&#10003;</span>
            <span v-else>5</span>
          </div>
        </div>
      </div>
      <div class="header-bottom">
        <h2>{{ title }}</h2>
      </div>
    </header>
  </template>
  
  <script>
  export default {
    name: 'HeaderComponent',
    props: {
      title: {
        type: String,
        required: true
      },
      step: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        clientName: '',
        effectiveDate: ''
      };
    },
    mounted() {
  const storedData = localStorage.getItem('deruloData');
  if (storedData) {
    try {
      const data = JSON.parse(storedData);
      const contactInfo = data.contact_info[0];

      this.clientName = contactInfo.named_insured || 'N/A';
      let effectiveDate = data.effective_date;

      const isoDatePattern = /^\d{4}-\d{2}-\d{2}$/;

      if (effectiveDate && isoDatePattern.test(effectiveDate)) {
        effectiveDate = new Date(effectiveDate);
      } else if (effectiveDate) {
        const parts = effectiveDate.split(/[-/]/);
        if (parts.length === 3) {
          effectiveDate = new Date(`${parts[2]}-${parts[0]}-${parts[1]}`);
        } else {
          effectiveDate = new Date(effectiveDate);
        }
      }

      if (effectiveDate && !isNaN(effectiveDate.getTime())) {
        // Adjust date manually if timezone causes issues
        effectiveDate.setMinutes(effectiveDate.getMinutes() + effectiveDate.getTimezoneOffset());

        this.effectiveDate = effectiveDate.toLocaleDateString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        });
      } else {
        this.effectiveDate = 'N/A';
      }
    } catch (error) {
      console.error('Error parsing stored data:', error);
    }
  } else {
    console.error('No data found in localStorage');
  }
}
}
</script>
  <style scoped>
  .logo-container {
    text-align: center;
    padding: 0;
  }
  
  .logo {
    width: 300px;
    height: 55px
  }

  @media (max-width: 400px) {
    .logo {
      width: 250px;
      height: 45px
    }
  }
  
  .header-content {
    text-align: center;
    margin-bottom: 5px;
  }
  
  .confirmation-text {
    font-size: 1.2em;
    color: #333;
  }
  
  .progress-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .progress-bar {
    display: flex;
    align-items: center;
  }
  
  .step {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #ddd;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 5px;
    position: relative;
  }
  
  .step.completed {
    background-color: #4CAF50;
    color: white;
  }
  
  .step.active {
    background-color: #8BC34A;
    color: white;
  }
  
  .line {
    width: 40px;
    height: 2px;
    background-color: #ddd;
  }
  
  .header-bottom {
    text-align: center;
  }
  
  .header-bottom h2 {
    font-size: 1.5em;
    color: #333;
  }
  </style>
  